<template>
    <div>
      <div class="bg-content padding15">
        <el-form size="small" label-width="55px" ref="searchRef" @submit.native.prevent>
          <el-row :gutter="24">
            <el-col :span="6" v-if="this.$partB()">
              <el-form-item label="公司">
                <el-select v-model="searchReq.companyId" placeholder="请选择" filterable @change="searchReq.page = 1; roleList();">
                  <el-option v-for="item in companyRes" :key="item.id" :label="item.companyName" :value="item.id"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="角色">
                <el-input v-model="searchReq.roleName" placeholder="请输入角色名"/>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" size="small" plain @click="searchReq.page = 1; roleList()"> <i class="fa fa-search"></i> 搜索</el-button>
              <el-button size="small" @click="searchReq.roleName = null">重置</el-button>
            </el-col>
          </el-row>
        </el-form>
        <el-button type="primary" size="small" style="float:right;" @click="addVisable" v-if="this.$hasPerm('Z018')">添加角色</el-button>
      </div>
      <div class="padding15 bg-content">
        <el-table size="small" :data="roleRes.list">
          <!--<el-table-column fixed property="id"  label="ID" min-width="50px"/>-->
          <el-table-column fixed property="roleName"  label="角色名称" min-width="140px"/>
          <el-table-column fixed label="状态" min-width="140px">
            <template slot-scope="scope">
              <span v-if="scope.row.status === '1'">生效</span>
              <span style="color: red;" v-if="scope.row.status === '0'">无效</span>
            </template>
          </el-table-column>
          <el-table-column fixed label="默认角色" min-width="140px">
            <template slot-scope="scope">
              <div v-if="scope.row.common === 1" style="color: #F56C6C;">是</div>
              <div v-if="scope.row.common === 0" style="color: #67C23A;">否</div>
            </template>
          </el-table-column>
          <el-table-column fixed property="createTime"  label="创建时间" min-width="140px"/>
          <el-table-column fixed property="updateTime"  label="更新时间" min-width="140px"/>
          <el-table-column fixed label="操作" min-width="140px" v-if="permZ016 || permZ018">
            <template slot-scope="scope">
              <!--甲方，默认角色显示查看-->
              <span v-if="partyA && scope.row.common === 1">
                <el-button type="text" size="small" @click="show(scope.row)" v-if="permZ016"><i class="el-icon-document"></i>&nbsp;查看</el-button>
              </span>
              <!--甲方，不能编辑默认角色-->
              <span v-else>
                <span v-if="permZ018">
                  <el-button type="text" size="small" @click="updateVisable(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                  <el-button type="text" size="small" @click="remove(scope.row.id)"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
                  <el-switch v-model="scope.row.status" active-value="1" inactive-value="0" value="0" @change="changeStatus(scope.row)"/>
                </span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="text center margin15-tb">
          <el-pagination
            background
            layout="prev, pager, next, sizes, total"
            :total="roleRes.totalRecords"
            :page-size="searchReq.limit"
            :current-page="searchReq.page"
            @current-change="currentChange"
            @size-change="sizeChange">
          </el-pagination>
        </div>
      </div>
      <!-- 添加角色 -->
      <el-dialog :title="title+'角色'" :visible.sync="roleVisible" width="60%" center>
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="公司" v-if="this.$partB() && reqBody.common == 0">
              <el-select v-model="reqBody.companyId" placeholder="请选择" filterable @change="permissionList" style="width: 100%;" v-if="addShow">
                <el-option v-for="item in companyRes" :key="item.id" :label="item.companyName" :value="item.id"/>
              </el-select>
              <el-select v-model="reqBody.companyId" placeholder="请选择" filterable @change="permissionList" style="width: 100%;" v-if="!addShow" disabled>
                <el-option v-for="item in companyRes" :key="item.id" :label="item.companyName" :value="item.id"/>
              </el-select>
            </el-form-item>
            <el-form-item label="角色名称">
              <el-input placeholder="请输入角色名称" v-model="reqBody.roleName"/>
            </el-form-item>
            <el-form-item label="权限">
              <el-transfer :data="permissionRes" v-model="reqBody.permissions" :titles="['未用有', '已拥有']" :props="{key:'id',label:'label'}"
              :filterable="true"/>
            </el-form-item>
            <el-form-item v-if="this.$partB()">
              <el-checkbox v-model="reqBody.common" :true-label="1" :false-label="0" v-if="addShow">为甲方公司默认角色</el-checkbox>
              <el-checkbox v-model="reqBody.common" :true-label="1" :false-label="0" disabled v-if="!addShow">为甲方公司默认角色</el-checkbox>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="roleVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="add" size="small" v-if="addShow">保存</el-button>
          <el-button type="primary" @click="update" size="small" v-if="!addShow">更新</el-button>
        </div>
      </el-dialog>
      <!-- 显示角色 -->
      <el-dialog title="查看角色" :visible.sync="roleDetailVisable" width="60%" center>
        <div>
          <el-form size="small" label-width="140px">
            <el-form-item label="角色名称">
              <el-input placeholder="请输入角色名称" v-model="detailRes.roleName"/>
            </el-form-item>
            <el-form-item label="权限">
              <el-transfer :data="permissionRes" v-model="detailRes.permissions" :titles="['未用有', '已拥有']" :props="{key:'id',label:'label'}"
                           :filterable="true"/>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="roleDetailVisable = false" size="small">取 消</el-button>
        </div>
      </el-dialog>
    </div>
</template>
<script>
export default {
  data() {
    return {
      companyRes: [],
      permissionRes: [],
      detailRes: {},
      searchReq: {
        roleName: null,
        companyId: null,
        page: 1,
        limit: 10,
        order: 'create_time',
        sort: 'desc'
      },
      roleRes: { 'totalRecords': 0, list: [] },
      reqBody: {
        id: null,
        roleName: null,
        permissions: [],
        common: null,
        companyId: null
      },
      roleVisible: false,
      addShow: true,
      title: null,
      roleDetailVisable: false,
      partyA: null,
      permZ016: false,
      permZ018: false
    };
  },
  methods: {
    // 公司列表
    companyList() {
      this.$ajax({
        method: 'GET',
        url: '/company/list'
      }).then((res) => {
        this.companyRes = res.data;
        if (this.companyRes.length > 0) {
          this.searchReq.companyId = this.$account().companyId;
        }
        this.roleList();
      });
    },
    // 角色列表
    roleList() {
      this.$ajax({
        method: 'POST',
        url: '/role/list',
        data: this.searchReq
      }).then((res) => {
        this.roleRes = res.data;
      });
    },
    currentChange(page) {
      this.searchReq.page = page;
      this.roleList();
    },
    // 显示条数
    sizeChange(num) {
      this.searchReq.limit = num;
      this.roleList();
    },
    // 添加角色框显示
    addVisable() {
      this.title = '创建';
      this.clearReq();
      // 默认为查询公司
      this.reqBody.companyId = this.searchReq.companyId;
      this.permissionList(this.reqBody.companyId);
      this.roleVisible = true;
      this.addShow = true;
    },
    add() {
      this.reqBody.companyId = this.$partA() ? this.$account().companyId : this.reqBody.companyId;
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/role/add',
        data: this.reqBody
      }).then(() => {
        this.roleVisible = false;
        // 刷新
        this.roleList();
      });
    },
    // 更新角色框显示
    updateVisable(row) {
      this.title = '编辑';
      this.clearReq();
      this.permissionList(row.companyId);
      this.detail(row.id);
      this.roleVisible = true;
      this.addShow = false;
    },
    show(row) {
      this.clearReq();
      this.permissionList(row.companyId);
      this.detail(row.id);
      this.roleDetailVisable = true;
    },
    update() {
      this.$ajax({
        method: 'GET',
        url: `/role/used/${this.reqBody.id}`
      }).then((res) => {
        this.$confirm(`该角色正在被${res.data}位用户使用，确定仍要更新吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$ajax({
            prompt: true,
            method: 'POST',
            url: `/role/update/${this.reqBody.id}`,
            data: this.reqBody
          }).then(() => {
            this.roleVisible = false;
            // 刷新
            this.roleList();
          });
        });
      });
    },
    clearReq() {
      // 清空
      this.reqBody.id = null;
      this.reqBody.roleName = null;
      this.reqBody.permissions = [];
      this.reqBody.common = 0;
      this.reqBody.companyId = null;
    },
    // 公司资源列表
    permissionList(companyId) {
      this.$ajax({
        method: 'GET',
        url: `/role/companyPermission/${companyId}`
      }).then((res) => {
        res.data.forEach((temp) => {
          if (temp.status === '0') {
            temp.label = `${temp.permissionName}(${temp.permissionCode})-已关闭`;
            temp.disabled = true;
          } else {
            temp.label = `${temp.permissionName}(${temp.permissionCode})`;
          }
        });
        this.permissionRes = res.data;
      });
    },
    detail(roleId) {
      this.detailRes = null;
      this.$ajax({
        method: 'GET',
        url: `/role/detail/${roleId}`
      }).then((res) => {
        this.detailRes = res.data;
        this.copyToReqBody();
      });
    },
    copyToReqBody() {
      this.reqBody.id = this.detailRes.id;
      this.reqBody.roleName = this.detailRes.roleName;
      this.reqBody.permissions = this.detailRes.permissions;
      this.reqBody.common = this.detailRes.common;
      this.reqBody.companyId = this.detailRes.companyId;
    },
    remove(roleId) {
      this.$ajax({
        method: 'GET',
        url: `/role/used/${roleId}`
      }).then((res) => {
        if (res.data > 0) {
          this.$notify.error({
            title: '提示',
            message: `该角色正在被${res.data}位用户使用，请先将使用该角色的用户更新至其他角色后再行删除。`
          });
        } else {
          this.$confirm('您确定要删除该角色吗, 是否继续？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$ajax({
              prompt: true,
              method: 'DELETE',
              url: `/role/remove/${roleId}`
            }).then(() => {
              // 刷新
              this.roleList();
            });
          });
        }
      });
    },
    changeStatus(row) {
      const title = row.status === '1' ? '开启' : '关闭';
      this.$ajax({
        method: 'GET',
        url: `/role/used/${row.id}`
      }).then((res) => {
        this.$confirm(`该角色正在被${res.data}位用户使用，确定仍要${title}吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$ajax({
            method: 'POST',
            url: `/role/status/${row.id}/${row.status}`
          }).then(() => {
            // 刷新
            this.roleList();
          });
        }).catch(() => {
          const status = row.status === '1' ? '0' : '1';
          row.status = status;
        });
      });
    }
  },
  mounted() {
    this.partyA = this.$partA();
    this.permZ016 = this.$hasPerm('Z016');
    this.permZ018 = this.$hasPerm('Z018');
    if (this.$partB()) {
      this.companyList();
    }
    if (this.$partA()) {
      this.searchReq.companyId = this.$account().companyId;
      this.roleList();
    }
  }
};
</script>
<style>
  div.el-transfer .el-transfer-panel {width: 36%;}
</style>



// WEBPACK FOOTER //
// src/page/main/permission/role.vue